import { EVEntry, GridFromJson } from '@uswitch/ev-core/react'
import { useEntity } from '@uswitch/ev-utils/lib/context/selectors'

import { contentId } from '@uswitch/ev-utils/lib/contentful'

const Grid = ({ content, prependContent, layout, ...props }) => {
  const { layout: layoutEntity } = useEntity(layout)
  const childrenArray = [prependContent]
    .concat(content.map(entity => <EVEntry {...entity} key={contentId(entity)} />))
    .filter(i => i)

  return <GridFromJson {...props} json={layoutEntity} childrenArray={childrenArray} />
}

export default Grid
